(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/game-card/animations.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/game-card/animations.js');
"use strict";


const gameRegeneratedAnimation = el => {
  const tl = gsap.timeline();
  tl.set(el, {
    filter: 'brightness(1)'
  });
  tl.to(el, {
    opacity: 0.3,
    duration: 0.1
  });
  tl.to(el, {
    opacity: 1,
    filter: 'brightness(0.5)',
    duration: 0.1
  });
  tl.to(el, {
    filter: 'brightness(1)',
    duration: 0.7
  });
  return tl;
};
const expireOrOpen = (hideEl, showEl, tlOptions) => {
  const tl = gsap.timeline(tlOptions);
  tl.to(hideEl, {
    opacity: 0,
    display: 'none',
    duration: 0.5
  });
  tl.to(showEl, {
    opacity: 1,
    display: 'block',
    duration: 0.5
  });
  return tl;
};
const toExpiredAnimation = (hideEl, showEl, opacityEl, tlOptions) => {
  const tl = expireOrOpen(hideEl, showEl, tlOptions);
  tl.to(opacityEl, {
    opacity: 0.5,
    duration: 0.5
  }, -0.5);
  return tl;
};
const toOpenAnimation = (hideEl, showEl, opacityEl, tlOptions) => {
  const tl = expireOrOpen(hideEl, showEl, tlOptions);
  tl.to(opacityEl, {
    opacity: 1,
    duration: 0.5
  }, 0.5);
  return tl;
};
svs.numbergames.fractiongames.components.gamecard.animations = {
  gameRegeneratedAnimation,
  toExpiredAnimation,
  toOpenAnimation
};

 })(window);